import script from "./contact-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact-modal.vue?vue&type=script&setup=true&lang=ts"

import "./contact-modal.vue?vue&type=style&index=0&id=9d6ca71e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d6ca71e"]])

export default __exports__